export default "__VITE_ASSET__29545d3b__"